export type BlogGroupingVariant = "liquid-glass" | "solid" | "plain";

const GROUPING_VARIANT_CLASS: Record<BlogGroupingVariant, string> = {
  "liquid-glass":
    "rounded-[28px] border border-black/10 bg-marketing-industry-card p-6 shadow-[0_16px_40px_rgba(0,61,91,.06)] md:p-8",
  solid:
    "rounded-[28px] border border-white/70 bg-marketing-industry-card p-6 shadow-[0_16px_40px_rgba(0,61,91,.08)] md:p-8",
  plain: "p-0",
};

export function getBlogGroupingClassName(variant: BlogGroupingVariant): string {
  return GROUPING_VARIANT_CLASS[variant];
}
